import { render, staticRenderFns } from "./IndexInfoItem.vue?vue&type=template&id=0626d324&scoped=true&"
import script from "./IndexInfoItem.vue?vue&type=script&lang=js&"
export * from "./IndexInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexInfoItem.vue?vue&type=style&index=0&id=0626d324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626d324",
  null
  
)

export default component.exports